
class Const {
    ERROR_COLOR = "rgb(255, 235, 235)";
    RESULT_SUCCESS = 'SUCCESS';
    START_TIMES = [
        { id: "7", value: "7時台", category: "スタート時刻", class: "start_time", checked: false },
        { id: "8", value: "8時台", category: "スタート時刻", class: "start_time", checked: false },
        { id: "9", value: "9時台", category: "スタート時刻", class: "start_time", checked: false },
        { id: "10", value: "10時台", category: "スタート時刻", class: "start_time", checked: false },
        { id: "11", value: "11時台以降", category: "スタート時刻", class: "start_time", checked: false }
    ];
    VERSION = "1.1";
    MAX_CAPACITY = 20;
    MIN_CAPACITY = 0;
    CHILD_AGE = 17;

    ENG_MONTH_ABBR = [
        {value: "01", abbrName: "JAN"}, 
        {value: "02", abbrName: "FEB"}, 
        {value: "03", abbrName: "MAR"}, 
        {value: "04", abbrName: "APR"}, 
        {value: "05", abbrName: "MAY"}, 
        {value: "06", abbrName: "JUN"}, 
        {value: "07", abbrName: "JUL"}, 
        {value: "08", abbrName: "AUG"}, 
        {value: "09", abbrName: "SEP"}, 
        {value: "10", abbrName: "OCT"}, 
        {value: "11", abbrName: "NOV"}, 
        {value: "12", abbrName: "DEC"}, 
    ]
    PASSPORT_VAILD_PERIOD = 15;

    // ZEUS決済ページ遷移用
    CLIENT_IP = 2014004873;
    SUCCESS_STR = "RTCC予約サイトへ戻る";
    FAILURE_STR = "RTCC予約サイトへ戻る";

    // カタログ
    MAX_DISP_NUM = 30;

    // 本番ドメイン
    RELEASE_PATH = "https://rsv.rtg.jp";
}


export default new Const();

